
import { computed, defineComponent, PropType } from "vue";
import UserListTableRow from "@/components/table/list/UserListTableRow/UserListTableRow.vue";
import { Teacher } from "@/ts/objects/entity/teacher";
import { getTeacherColumns } from "@/ts/app/columns/def/teacher/teacher-column";
import { isNullish } from "@/ts/utils/common-util";

export default defineComponent({
  name: "TeacherListTableRow",
  components: { UserListTableRow },
  props: {
    horizontalMargin: { type: Number, required: true },
    iconCellWidth: { type: Number, required: true },
    nameCellWidth: { type: Number, required: true },
    minHeight: { type: Number, required: true },
    maxHeight: { type: Number, required: true },

    styleType: { type: Number as PropType<0 | 1>, required: true },

    schoolYear: { type: Number, required: true },
    teacher: { type: Object as PropType<Teacher>, required: true },
    columnVisibility: {
      type: Object as PropType<Record<string, boolean>>,
      required: true,
    },

    /**
     * ユーザーIDから、編集画面のパスを取得する。
     * 未指定の場合、編集画面へのリンクが現れない。
     */
    userIdToEditPath: {
      type: Function as PropType<(userId: string) => string>,
      required: false,
    },

    /**
     * trueなら、ユーザー項目などをリンク化する。
     */
    linkEnabled: { type: Boolean, required: true },
  },
  setup(props) {
    const columns = computed(() =>
      getTeacherColumns(props.schoolYear, props.teacher),
    );
    const editPath = computed(() => {
      const userIdToEditPath = props.userIdToEditPath;
      if (isNullish(userIdToEditPath)) {
        return null;
      }
      return userIdToEditPath(props.teacher.userId);
    });

    return {
      columns,
      editPath,
    };
  },
});
